import DateRange from './main.vue';

/* istanbul ignore next */
DateRange.install = function(Vue) {
  Vue.component(DateRange.name, DateRange);
};

export default DateRange;
